import { gsap } from "gsap";
import { CSSPlugin } from "gsap/CSSPlugin";
gsap.registerPlugin(CSSPlugin);

$(function () {
  const $chart = $('.js-linear-chart-bar');
  $chart.each( (i, el) => {
    let val = parseInt($(el).attr('data-progress'));
    
    if (isNaN(val)) {
      val = 0; 
    }
    else{
      if (val < 0) { val = 0;}
      if (val > 100) { val = 100;}
      
      const width = val + '%'
      
      gsap.to(el, { duration: 1, width: width });
    }
  } )
})